import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment-timezone";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import langDE from "../../constants/language_DE";
import langEN from "../../constants/language_EN";
import langES from "../../constants/language_ES";
import langFR from "../../constants/language_FR";
import langNL from "../../constants/language_NL";
import langPL from "../../constants/language_PL";
import { languages } from "../../constants/languages";
import tournamentStatus from "../../constants/TournamentStatus";
import TournamentTypes from "../../constants/TournamentTypes";
import CloseTournamentContainer from "./CloseTournamentContainer";
import UserContainer from "./UserContainer";
import { sumMatchProgressForTournament } from "../../util/MatchProgressFasesLogic";

const EXPORT_SPORT_NAMES = {
  en: ((langEN || {}).general || {}).sports || {},
  nl: ((langNL || {}).general || {}).sports || {},
  fr: ((langFR || {}).general || {}).sports || {},
  de: ((langDE || {}).general || {}).sports || {},
  es: ((langES || {}).general || {}).sports || {},
  pl: ((langPL || {}).general || {}).sports || {},
};

const ALL_SPORT_NAME_TO_KEY = {};
[langEN, langNL, langFR, langDE, langES, langPL].forEach((languageSet) => {
  const sports = ((languageSet || {}).general || {}).sports || {};
  Object.keys(sports).forEach((key) => {
    ALL_SPORT_NAME_TO_KEY[sports[key]] = key;
  });
});

const SPORT_KEY_BY_ID = TournamentTypes.reduce((result, sport) => {
  if (sport && sport.id !== undefined) {
    const sportKey = ALL_SPORT_NAME_TO_KEY[sport.name];
    if (sportKey) {
      result[sport.id] = sportKey;
    }
  }
  return result;
}, {});

class UpgradesTableContainer extends Component {
  state = {
    tournaments1: [],
    tournaments2: [],
    tournaments3: [],
    loading1: false,
    loading2: false,
    loading3: false,
    analyzingAbuse: false,
    exportingClosedTournaments: false,
    abuseOnly: false,
    abuseFlaggedById: {},
    abuseMetaByTournamentId: {},
    page: 0,

    start: moment(),
    end: moment().add(3, "days"),

    summarizingMatchProgress: false,
    matchProgressByTournamentId: {},
  };

  loadTournaments = () => {
    this.setState({
      tournaments1: [],
      tournaments2: [],
      tournaments3: [],
      loading1: true,
      loading2: true,
      loading3: true,
      abuseOnly: false,
      abuseFlaggedById: {},
      abuseMetaByTournamentId: {},
      page: 0,
      matchProgressByTournamentId: {},
      summarizingMatchProgress: false,
    });
    window.firebase
      .firestore()
      .collection("tournaments")
      .where("date", "<=", this.state.end.unix())
      .where("date", ">=", this.state.start.unix())
      .where("status", "==", 1)
      .get()
      .then(async (querySnapshot) => {
        let tournaments = [];
        querySnapshot.forEach((doc) => {
          let tournament = doc.data();
          tournament["pack"] = 1;
          tournament["id"] = doc.id;
          tournaments.push(tournament);
        });
        tournaments = await this.enrichTournamentsWithLastDayDate(tournaments);
        this.setState({ tournaments1: tournaments, loading1: false });
      });
    window.firebase
      .firestore()
      .collection("tournaments")
      .where("date", "<=", this.state.end.unix())
      .where("date", ">=", this.state.start.unix())
      .where("status", "==", 2)
      .get()
      .then(async (querySnapshot) => {
        let tournaments = [];
        querySnapshot.forEach((doc) => {
          let tournament = doc.data();
          tournament["pack"] = 2;
          tournament["id"] = doc.id;
          tournaments.push(tournament);
        });
        tournaments = await this.enrichTournamentsWithLastDayDate(tournaments);
        this.setState({ tournaments2: tournaments, loading2: false });
      });
    window.firebase
      .firestore()
      .collection("tournaments")
      .where("date", "<=", this.state.end.unix())
      .where("date", ">=", this.state.start.unix())
      .where("status", "==", 3)
      .get()
      .then(async (querySnapshot) => {
        let tournaments = [];
        querySnapshot.forEach((doc) => {
          let tournament = doc.data();
          tournament["pack"] = 3;
          tournament["id"] = doc.id;
          tournaments.push(tournament);
        });
        tournaments = await this.enrichTournamentsWithLastDayDate(tournaments);
        this.setState({ tournaments3: tournaments, loading3: false });
      });
  };

  getAllLoadedTournaments = () => {
    return this.state.tournaments1
      .concat(this.state.tournaments2)
      .concat(this.state.tournaments3)
      .sort((a, b) => b.date - a.date)
      .filter((t) => this.props.admins.indexOf(t.uid) === -1);
  };

  getChunkedList = (list, size) => {
    let chunks = [];
    for (let i = 0; i < list.length; i += size) {
      chunks.push(list.slice(i, i + size));
    }
    return chunks;
  };

  enrichTournamentsWithLastDayDate = async (tournaments) => {
    if (!tournaments.length) {
      return tournaments;
    }
    const db = window.firebase.firestore();
    const chunkSize = 25;
    const out = [];
    for (let i = 0; i < tournaments.length; i += chunkSize) {
      const chunk = tournaments.slice(i, i + chunkSize);
      const chunkResults = await Promise.all(
        chunk.map(async (tournament) => {
          let lastUnix = tournament.date || 0;
          try {
            const latestDaySnap = await db
              .collection("tournaments")
              .doc(tournament.id)
              .collection("days")
              .orderBy("date", "desc")
              .limit(1)
              .get();
            if (!latestDaySnap.empty) {
              const latestDayDate = (latestDaySnap.docs[0].data() || {}).date;
              if (latestDayDate != null && latestDayDate > lastUnix) {
                lastUnix = latestDayDate;
              }
            }
          } catch (error) {
            console.error(
              "Error loading match days for tournament",
              tournament.id,
              error,
            );
          }
          return { ...tournament, lastMatchDayDate: lastUnix };
        }),
      );
      out.push(...chunkResults);
    }
    return out;
  };

  formatTournamentDateCell = (tournament) => {
    if (!tournament.date) {
      return "";
    }
    const dateFormat = "D MMMM YYYY";
    const startMoment = moment.unix(tournament.date);
    const endUnix =
      tournament.lastMatchDayDate != null
        ? tournament.lastMatchDayDate
        : tournament.date;
    const endMoment = moment.unix(endUnix);
    const startStr = startMoment.format(dateFormat);
    if (startMoment.isSame(endMoment, "day")) {
      return startStr;
    }
    return `${startStr} – ${endMoment.format(dateFormat)}`;
  };

  getTimestampAsUnix = (timestamp) => {
    if (!timestamp) {
      return null;
    }
    if (timestamp.toDate) {
      return moment(timestamp.toDate()).unix();
    }
    if (timestamp.seconds) {
      return timestamp.seconds;
    }
    if (timestamp instanceof Date) {
      return moment(timestamp).unix();
    }
    return null;
  };

  escapeCsv = (value) => {
    const stringValue =
      value === null || value === undefined ? "" : String(value);
    const escaped = stringValue.replace(/"/g, '""');
    if (
      escaped.includes(",") ||
      escaped.includes('"') ||
      escaped.includes("\n")
    ) {
      return `"${escaped}"`;
    }
    return escaped;
  };

  downloadCsv = (csvData, filename) => {
    const blob = new Blob([csvData], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  getExportLanguage = (registeredLang) => {
    const normalizedLanguage = (registeredLang || "").toLowerCase();
    if (
      normalizedLanguage === "nl" ||
      normalizedLanguage.startsWith("nl-") ||
      normalizedLanguage === "be" ||
      normalizedLanguage.startsWith("be-")
    ) {
      return "nl";
    }
    if (normalizedLanguage === "fr" || normalizedLanguage.startsWith("fr-")) {
      return "fr";
    }
    if (normalizedLanguage === "de" || normalizedLanguage.startsWith("de-")) {
      return "de";
    }
    if (normalizedLanguage === "es" || normalizedLanguage.startsWith("es-")) {
      return "es";
    }
    if (normalizedLanguage === "pl" || normalizedLanguage.startsWith("pl-")) {
      return "pl";
    }
    return "en";
  };

  getSportExportLabel = (sportId, registeredLang) => {
    const exportLanguage = this.getExportLanguage(registeredLang);
    const unknownSportLabels = {
      en: "sports tournament",
      fr: "tournoi sportif",
      nl: "sporttoernooi",
      de: "Sportturnier",
      es: "torneo deportivo",
      pl: "turniej sportowy",
    };
    if (sportId === 52) {
      return unknownSportLabels[exportLanguage];
    }
    const sport = TournamentTypes.find((type) => type.id === sportId);
    if (!sport) {
      return unknownSportLabels[exportLanguage];
    }

    const sportKey = SPORT_KEY_BY_ID[sport.id];
    const translatedSportName =
      (sportKey && EXPORT_SPORT_NAMES[exportLanguage][sportKey]) || sport.name;
    const exportSportName =
      exportLanguage === "en" && sportKey === "football"
        ? "football"
        : exportLanguage === "nl" && sportKey === "futsal"
          ? "zaalvoetbal"
          : translatedSportName;

    if (!exportSportName) {
      return unknownSportLabels[exportLanguage];
    }

    const normalizedSportName =
      exportLanguage === "de"
        ? exportSportName
        : exportSportName.toLocaleLowerCase(
            exportLanguage === "fr"
              ? "fr-FR"
              : exportLanguage === "nl"
                ? "nl-NL"
                : exportLanguage === "es"
                  ? "es-ES"
                  : exportLanguage === "pl"
                    ? "pl-PL"
                    : "en-US",
          );

    if (exportLanguage === "fr") {
      return `tournoi de ${normalizedSportName}`;
    }
    if (exportLanguage === "nl") {
      return `${normalizedSportName}toernooi`;
    }
    if (exportLanguage === "de") {
      return `${normalizedSportName}turnier`;
    }
    if (exportLanguage === "es") {
      return `torneo de ${normalizedSportName}`;
    }
    if (exportLanguage === "pl") {
      return `turniej ${normalizedSportName}`;
    }
    return `${normalizedSportName} tournament`;
  };

  getParticipantCountLabel = (tournament, registeredLang) => {
    const exportLanguage = this.getExportLanguage(registeredLang);
    const isIndividualPlayers = !!tournament.individualPlayers;
    const labelsByLanguage = {
      en: {
        teams: "teams",
        players: "players",
        manyTeams: "many teams",
        manyPlayers: "many players",
      },
      fr: {
        teams: "équipes",
        players: "joueurs",
        manyTeams: "beaucoup d'équipes",
        manyPlayers: "beaucoup de joueurs",
      },
      nl: {
        teams: "teams",
        players: "spelers",
        manyTeams: "veel teams",
        manyPlayers: "veel spelers",
      },
      de: {
        teams: "Teams",
        players: "Spieler",
        manyTeams: "viele Teams",
        manyPlayers: "viele Spieler",
      },
      es: {
        teams: "equipos",
        players: "jugadores",
        manyTeams: "muchos equipos",
        manyPlayers: "muchos jugadores",
      },
      pl: {
        teams: "drużyn",
        players: "zawodników",
        manyTeams: "wiele drużyn",
        manyPlayers: "wielu zawodników",
      },
    };
    const labels = labelsByLanguage[exportLanguage] || labelsByLanguage.en;
    const participantCount = Number(tournament.numTeams);

    if (!participantCount || participantCount <= 0) {
      return isIndividualPlayers ? labels.manyPlayers : labels.manyTeams;
    }

    return `${participantCount} ${
      isIndividualPlayers ? labels.players : labels.teams
    }`;
  };

  handleExportClosedTournaments = async () => {
    const tournaments = this.getAllLoadedTournaments();
    if (!tournaments.length) {
      return;
    }

    this.setState({ exportingClosedTournaments: true });

    try {
      const tournamentIdChunks = this.getChunkedList(
        tournaments.map((tournament) => tournament.id),
        10,
      );
      const closedTournamentIds = {};

      for (let i = 0; i < tournamentIdChunks.length; i++) {
        const chunk = tournamentIdChunks[i];
        const statusSnapshot = await window.firebase
          .firestore()
          .collection("tournamentStatus")
          .where(window.firebase.firestore.FieldPath.documentId(), "in", chunk)
          .where("closed", "==", true)
          .get();

        statusSnapshot.forEach((doc) => {
          closedTournamentIds[doc.id] = true;
        });
      }

      const closedTournaments = tournaments
        .filter((tournament) => closedTournamentIds[tournament.id])
        .sort((a, b) => b.date - a.date);

      const userIds = [
        ...new Set(
          closedTournaments.map((tournament) => tournament.uid).filter(Boolean),
        ),
      ];
      const userChunks = this.getChunkedList(userIds, 10);
      const usersById = {};

      for (let i = 0; i < userChunks.length; i++) {
        const chunk = userChunks[i];
        const userSnapshot = await window.firebase
          .firestore()
          .collection("users")
          .where(window.firebase.firestore.FieldPath.documentId(), "in", chunk)
          .get();

        userSnapshot.forEach((doc) => {
          usersById[doc.id] = doc.data() || {};
        });
      }

      const headers = [
        "email",
        "registeredLang",
        "tournament.name",
        "tournament.numTeams",
        "tournament.numMatches",
        "sport",
      ];

      const rows = closedTournaments.map((tournament) => {
        const user = usersById[tournament.uid] || {};
        const exportLanguage = user.registeredLang || (tournament.lang || [])[0] || "";
        return [
          this.escapeCsv(user.email || ""),
          this.escapeCsv(exportLanguage),
          this.escapeCsv(tournament.name || ""),
          this.escapeCsv(
            this.getParticipantCountLabel(tournament, exportLanguage),
          ),
          this.escapeCsv(tournament.numMatches || ""),
          this.escapeCsv(
            this.getSportExportLabel(tournament.sportId, exportLanguage),
          ),
        ].join(",");
      });

      const csvData = [headers.join(","), ...rows].join("\n");
      const filename = `closed_tournaments_export_${moment().format(
        "YYYY-MM-DD_HH-mm-ss",
      )}.csv`;
      this.downloadCsv(csvData, filename);
      this.setState({ exportingClosedTournaments: false });
    } catch (error) {
      console.error("Error exporting closed tournaments:", error);
      this.setState({ exportingClosedTournaments: false });
    }
  };

  handleAnalyzeAbuse = async () => {
    let tournaments = this.getAllLoadedTournaments();
    if (!tournaments.length) {
      this.setState({
        abuseOnly: true,
        abuseFlaggedById: {},
        abuseMetaByTournamentId: {},
        page: 0,
      });
      return;
    }

    this.setState({ analyzingAbuse: true });
    const upgradeYearSeconds = 365 * 24 * 60 * 60;
    const tournamentIds = tournaments.map((tournament) => tournament.id);
    const idChunks = this.getChunkedList(tournamentIds, 10);
    const latestPaidUpgradeByTournamentId = {};

    try {
      for (let i = 0; i < idChunks.length; i++) {
        const chunk = idChunks[i];
        const querySnapshot = await window.firebase
          .firestore()
          .collection("upgrades")
          .where("tournamentId", "in", chunk)
          .get();

        querySnapshot.forEach((doc) => {
          let upgrade = doc.data();
          if (!upgrade.payed || !upgrade.tournamentId || !upgrade.timestamp) {
            return;
          }

          const upgradeTimestamp = this.getTimestampAsUnix(upgrade.timestamp);
          if (!upgradeTimestamp) {
            return;
          }

          const existingUpgrade =
            latestPaidUpgradeByTournamentId[upgrade.tournamentId];
          if (
            !existingUpgrade ||
            upgradeTimestamp > existingUpgrade.timestamp
          ) {
            latestPaidUpgradeByTournamentId[upgrade.tournamentId] = {
              timestamp: upgradeTimestamp,
            };
          }
        });
      }

      let abuseFlaggedById = {};
      let abuseMetaByTournamentId = {};
      tournaments.forEach((tournament) => {
        const upgradeData = latestPaidUpgradeByTournamentId[tournament.id];
        if (!upgradeData || !tournament.date) {
          return;
        }
        const secondsBetween = tournament.date - upgradeData.timestamp;
        if (secondsBetween > upgradeYearSeconds) {
          abuseFlaggedById[tournament.id] = true;
          abuseMetaByTournamentId[tournament.id] = {
            upgradeTimestamp: upgradeData.timestamp,
            daysBetween: Math.floor(secondsBetween / (24 * 60 * 60)),
          };
        }
      });

      this.setState({
        analyzingAbuse: false,
        abuseOnly: true,
        abuseFlaggedById: abuseFlaggedById,
        abuseMetaByTournamentId: abuseMetaByTournamentId,
        page: 0,
      });
    } catch (error) {
      console.error("Error analyzing abuse candidates:", error);
      this.setState({ analyzingAbuse: false });
    }
  };

  handleShowAllTournaments = () => {
    this.setState({ abuseOnly: false, page: 0 });
  };

  handleSummarizeMatchProgress = async () => {
    const tournaments = this.getAllLoadedTournaments();
    if (!tournaments.length) {
      return;
    }
    this.setState({
      summarizingMatchProgress: true,
      matchProgressByTournamentId: {},
    });
    const db = window.firebase.firestore();
    const matchProgressByTournamentId = {};
    const chunkSize = 15;
    try {
      for (let i = 0; i < tournaments.length; i += chunkSize) {
        const chunk = tournaments.slice(i, i + chunkSize);
        await Promise.all(
          chunk.map(async (tournament) => {
            try {
              const tRef = db.collection("tournaments").doc(tournament.id);
              const [matchesSnap, poulesSnap, bracketsSnap] = await Promise.all([
                tRef.collection("matches").get(),
                tRef.collection("poules").get(),
                tRef.collection("brackets").get(),
              ]);
              const poulesByKey = {};
              poulesSnap.forEach((doc) => {
                poulesByKey[doc.id] = { ...doc.data(), id: doc.id };
              });
              const bracketsByKey = {};
              bracketsSnap.forEach((doc) => {
                bracketsByKey[doc.id] = { ...doc.data(), id: doc.id };
              });
              const matches = [];
              matchesSnap.forEach((doc) => {
                let m = doc.data();
                if (m.day === undefined) {
                  m.day = "0";
                }
                m.id = doc.id;
                matches.push(m);
              });
              const counts = sumMatchProgressForTournament(
                matches,
                poulesByKey,
                bracketsByKey,
                tournament,
              );
              matchProgressByTournamentId[tournament.id] = {
                played: counts.played,
                scheduled: counts.scheduled,
              };
            } catch (error) {
              console.error(
                `Error summarizing match progress for tournament ${tournament.id}:`,
                error,
              );
              matchProgressByTournamentId[tournament.id] = {
                played: 0,
                scheduled: 0,
                error: true,
              };
            }
          }),
        );
        this.setState({
          matchProgressByTournamentId: { ...matchProgressByTournamentId },
        });
      }
      this.setState({
        summarizingMatchProgress: false,
        matchProgressByTournamentId,
      });
    } catch (error) {
      console.error("Error summarizing match progress:", error);
      this.setState({ summarizingMatchProgress: false });
    }
  };

  // UNSAFE_componentWillMount = () => {
  //   const timestamp3MonthsAgo = moment().subtract(3, "months").unix();
  // };

  handleStartChange = (date) => {
    this.setState({
      start: date,
    });
  };
  handleEndChange = (date) => {
    this.setState({
      end: date,
    });
  };

  render() {
    const allLoadedTournaments = this.getAllLoadedTournaments();
    let tournaments = allLoadedTournaments;
    if (this.state.abuseOnly) {
      tournaments = tournaments.filter(
        (tournament) => this.state.abuseFlaggedById[tournament.id],
      );
    }
    const flaggedCount = Object.keys(this.state.abuseFlaggedById).length;
    let numPages = Math.ceil(tournaments.length / 100);
    let pageButtons = [];
    for (let i = 0; i < numPages; i++) {
      pageButtons.push(
        <div
          key={i}
          style={{
            cursor: "pointer",
            fontWeight: this.state.page === i ? "bold" : "normal",
            margin: 10,
          }}
          onClick={() => {
            this.setState({ page: i });
          }}
        >
          {i + 1}
        </div>,
      );
    }
    tournaments = tournaments.slice(
      this.state.page * 100,
      (this.state.page + 1) * 100,
    );
    return (
      <div style={{ width: "100%", marginTop: 10, padding: "0 20px 20px" }}>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "baseline",
            paddingLeft: 10,
          }}
        >
          <KeyboardDatePicker
            margin="normal"
            name="start"
            label="Start"
            format={languages.createTournament.dateFormat}
            cancelLabel={languages.createTournament.cancel}
            autoOk={true}
            value={this.state.start}
            onChange={this.handleStartChange}
            placeholder={languages.createTournament.datePlaceholder}
            invalidLabel={languages.createTournament.invalidDateLabel}
          />
          <KeyboardDatePicker
            margin="normal"
            name="end"
            label="End"
            format={languages.createTournament.dateFormat}
            cancelLabel={languages.createTournament.cancel}
            autoOk={true}
            value={this.state.end}
            onChange={this.handleEndChange}
            placeholder={languages.createTournament.datePlaceholder}
            invalidLabel={languages.createTournament.invalidDateLabel}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={this.loadTournaments}
            style={{ height: "30px" }}
            disabled={
              this.state.loading1 ||
              this.state.loading2 ||
              this.state.loading3 ||
              this.state.analyzingAbuse ||
              this.state.exportingClosedTournaments ||
              this.state.summarizingMatchProgress
            }
          >
            Submit
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={this.handleSummarizeMatchProgress}
            style={{ height: "30px" }}
            disabled={
              this.state.loading1 ||
              this.state.loading2 ||
              this.state.loading3 ||
              this.state.analyzingAbuse ||
              this.state.exportingClosedTournaments ||
              this.state.summarizingMatchProgress ||
              allLoadedTournaments.length === 0
            }
          >
            {this.state.summarizingMatchProgress
              ? "Summarizing…"
              : "Summarize matches"}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={this.handleAnalyzeAbuse}
            style={{ height: "30px" }}
            disabled={
              this.state.loading1 ||
              this.state.loading2 ||
              this.state.loading3 ||
              this.state.analyzingAbuse ||
              this.state.exportingClosedTournaments ||
              this.state.summarizingMatchProgress ||
              allLoadedTournaments.length === 0
            }
          >
            {this.state.analyzingAbuse ? "Analyzing..." : "Analyze abuse"}
          </Button>
          <Button
            variant="contained"
            onClick={this.handleExportClosedTournaments}
            style={{ height: "30px" }}
            disabled={
              this.state.loading1 ||
              this.state.loading2 ||
              this.state.loading3 ||
              this.state.analyzingAbuse ||
              this.state.exportingClosedTournaments ||
              this.state.summarizingMatchProgress ||
              allLoadedTournaments.length === 0
            }
          >
            {this.state.exportingClosedTournaments
              ? "Exporting..."
              : "Export closed CSV"}
          </Button>
          {this.state.abuseOnly && (
            <Button
              variant="outlined"
              onClick={this.handleShowAllTournaments}
              style={{ height: "30px" }}
              disabled={
                this.state.analyzingAbuse ||
                this.state.exportingClosedTournaments ||
                this.state.summarizingMatchProgress
              }
            >
              Show all
            </Button>
          )}
        </div>
        {this.state.abuseOnly && (
          <div style={{ marginLeft: 10, marginBottom: 8 }}>
            {flaggedCount + " tournaments flagged for manual review"}
          </div>
        )}

        {!this.state.loading1 &&
          !this.state.loading2 &&
          !this.state.loading3 &&
          !this.state.analyzingAbuse && (
            <div>
              <div style={{ display: "flex" }}>{pageButtons}</div>
              <Table size="small">
                <TableBody>
                  {tournaments.map((tournament) => {
                    const matchProgress =
                      this.state.matchProgressByTournamentId[tournament.id];
                    return (
                    <TableRow key={tournament.id}>
                      <TableCell>
                        {this.formatTournamentDateCell(tournament)}
                      </TableCell>
                      <TableCell
                        title="Played with result / scheduled (same rules as results progress)"
                        style={
                          matchProgress &&
                          matchProgress.scheduled > 0 &&
                          matchProgress.played === matchProgress.scheduled
                            ? { color: "#2e7d32", fontWeight: 600 }
                            : undefined
                        }
                      >
                        {matchProgress
                          ? `${matchProgress.played}/${matchProgress.scheduled}`
                          : this.state.summarizingMatchProgress
                            ? "…"
                            : ""}
                      </TableCell>
                      {this.state.abuseOnly && (
                        <TableCell>
                          {moment
                            .unix(
                              (
                                this.state.abuseMetaByTournamentId[
                                  tournament.id
                                ] || {}
                              ).upgradeTimestamp || 0,
                            )
                            .format("D MMMM YYYY HH:mm")}
                        </TableCell>
                      )}
                      {this.state.abuseOnly && (
                        <TableCell>
                          {
                            (
                              this.state.abuseMetaByTournamentId[
                                tournament.id
                              ] || {}
                            ).daysBetween
                          }
                        </TableCell>
                      )}
                      <TableCell>
                        <Link to={"/admin/" + tournament.uid}>User</Link>
                      </TableCell>
                      <TableCell>
                        <UserContainer
                          admins={this.props.admins}
                          uid={tournament.uid}
                          tournamentList={true}
                          user={this.props.user}
                        />
                      </TableCell>
                      <TableCell>
                        {tournamentStatus[tournament.pack].name}
                      </TableCell>
                      <TableCell>
                        <CloseTournamentContainer tournament={tournament} />
                      </TableCell>
                      <TableCell>{tournament.name}</TableCell>
                      <TableCell>
                        {tournament.lang && tournament.lang[0]}
                      </TableCell>
                      <TableCell>{tournament.nvdCode ? "NVD" : ""}</TableCell>
                      <TableCell>
                        {tournament.liveLink && (
                          <a
                            href={
                              "https://tournifyapp.com/live/" +
                              tournament.liveLink +
                              "/schedule"
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            alt=""
                          >
                            {"https://tournifyapp.com/live/" +
                              tournament.liveLink}
                          </a>
                        )}
                      </TableCell>
                      <TableCell>
                        <Link
                          to={"/tournament/" + tournament.id}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open
                        </Link>
                      </TableCell>
                    </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          )}
      </div>
    );
  }
}

export default UpgradesTableContainer;
